<div class="relative inline-block text-left" #container>
  <ng-container *ngTemplateOutlet="dropdownTrigger(); context: context()" />

  @if (!dropdownTrigger()) {
    <div
      role="button"
      class="inline-flex items-center justify-center bg-transparent p-1 text-neutral-low-dark shadow-sm transition-all duration-150 data-[expanded='true']:bg-brand-primary-lightest data-[expanded='true']:text-brand-primary-pure hover:bg-neutral-hight-light focus:outline-none focus:ring-2 focus:ring-brand-primary-pure focus:ring-offset-2"
      [attr.data-expanded]="expanded() ? 'true' : 'false'"
      [ngClass]="{
        'rounded-full': variant() === 'icon',
        'rounded-md': variant() === 'text' || variant() === 'both',
        'text-sm font-medium': variant() === 'text' || variant() === 'both'
      }"
      [attr.id]="'menu-button-' + uniqueId()"
      [attr.aria-haspopup]="hasCustomContent() ? 'true' : 'menu'"
      [attr.aria-expanded]="expanded()"
      [attr.aria-controls]="'menu-' + uniqueId()"
      (click)="toggleExpanded()"
    >
      <span class="sr-only">Open options</span>

      @if (variant() === 'text' || variant() === 'both') {
        <span
          [ngClass]="{
            'mr-1': variant() === 'both'
          }"
        >
          {{ name() }}
        </span>
      }

      @if (variant() === 'icon' || variant() === 'both') {
        <ng-icon [name]="icon()" size="20" />
      }
    </div>
  }

  @if (expanded() !== null) {
    <!-- Outer node: measured by the position observer and never scaled, so its
         geometry stays stable while the inner node animates. Scaling THIS node
         would make its own resize (mid-transition) retrigger the position
         calculation, and since `top`/`left` are also transitioned, that shows
         up as an extra slide layered on top of the scale animation. -->
    <div
      #menuElement
      class="dropdown-menu z-100 absolute transition-all ease-in-out focus:outline-none"
      [ngClass]="{
        invisible: !expanded(),
        visible: expanded(),
        'w-56': size() === 'base',
        'w-64': size() === 'lg'
      }"
      role="menu"
      aria-orientation="vertical"
      [attr.aria-labelledby]="'menu-button-' + uniqueId()"
      tabindex="-1"
    >
      <div
        #menuContent
        class="max-h-[calc(100vh-2rem)] w-full overflow-y-auto overflow-x-hidden rounded-md border border-neutral-hight-medium bg-neutral-hight-light shadow-lg transition-all ease-in-out"
        [ngClass]="{
          'scale-95 opacity-0': !expanded(),
          'scale-100 opacity-100': expanded()
        }"
      >
        @if (hasCustomContent()) {
          <ng-container
            *ngTemplateOutlet="dropdownContent(); context: context()"
          />
        } @else {
          <div class="py-1" role="none">
            @for (item of renderItems(); track $index) {
              @if (item.static) {
                <div
                  class="select-none border-neutral-hight-medium px-4 py-2 text-xs font-normal text-neutral-low-medium"
                  [class.border-t]="!$first"
                  [class.hidden]="item.hidden"
                  role="presentation"
                >
                  {{ item.name }}
                </div>
              } @else {
                <button
                  (click)="onActionDispatch(item, $index)"
                  class="flex w-full cursor-pointer items-center !gap-3 !px-4 py-2 text-sm font-medium transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60"
                  [ngClass]="{
                    'text-feedback-warning-pure enabled:hover:bg-feedback-warning-light/35 enabled:hover:text-feedback-warning-medium':
                      item.name?.toLowerCase() === 'excluir' ||
                      item.name?.toLowerCase() === 'deletar' ||
                      item.name?.toLowerCase() === 'remover' ||
                      item.name?.toLowerCase() === 'sair',
                    'text-neutral-low-dark enabled:hover:bg-brand-primary-lighter enabled:hover:text-neutral-low-pure':
                      item.name?.toLowerCase() !== 'excluir' &&
                      item.name?.toLowerCase() !== 'deletar' &&
                      item.name?.toLowerCase() !== 'remover' &&
                      item.name?.toLowerCase() !== 'sair',
                    hidden: item.hidden
                  }"
                  [disabled]="item.disabled || loadingIndex() !== null"
                  role="menuitem"
                  tabindex="-1"
                  id="menu-item-{{ $index }}"
                  [attr.data-tracking-id]="item.tracking?.id"
                  [attr.data-tracking-object]="
                    item.tracking?.data
                      ? (item.tracking?.data | json)
                      : undefined
                  "
                >
                  @if (loadingIndex() === $index) {
                    <ui-spin-loader size="sm" />
                  } @else if (item.icon) {
                    <ng-icon [name]="item.icon" size="18"></ng-icon>
                  }
                  {{ item.name }}
                </button>
              }
            }
          </div>
        }
      </div>
    </div>
  }
</div>

<div [uiOverlay]="expanded()" (clickOutside)="toggleExpanded()"></div>
